import { motion } from "framer-motion";

interface HeroSimpleProps {
	title: string;
	subTitle?: string;
	updatedDate: string | Date;
}

import { Shield } from "lucide-react";

export default function HeroSimple({ title, subTitle, updatedDate }: HeroSimpleProps) {
	const lastUpdatedDate = () => {
		if (typeof updatedDate === "string") {
			const date = new Date(updatedDate);
			return date.toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
		}
		return updatedDate.toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
	}
	return (
		<section className="py-20 px-4 bg-newTheme-cotton">
			<div className="max-w-4xl mx-auto text-center">
				<motion.div
					initial={{ opacity: 0, y: 30 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8 }}
				>
					<div className="bg-primary-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
						<Shield className="h-8 w-8 text-primary-700" />
					</div>
					<h1 className="font-light text-black font-abc-prophet text-4xl leading-tight lg:text-[58px] lg:leading-[76px] mb-6">
						{title}
					</h1>
					{
						subTitle && (
							<p className="text-xl lg:text-[24px] text-black font-karla lg:leading-9 mb-4">
								{subTitle}
							</p>
						)
					}
					<p className="text-sm text-black font-karla">
						Last updated: <time dateTime={lastUpdatedDate()}>{lastUpdatedDate()}</time>
					</p>
				</motion.div>
			</div>
		</section>
	)
}